import settingsTableView from './settingsTableComponent.html';
import './settingsTableComponent.css';
import _ from 'lodash';

export function settingsTableComponent() {
	return {
		bindings: {
			settings: '<',
			settingsScope: '<',
		},
		controllerAs: 'vm',
		controller: settingsTableComponentCtrl,
		template: settingsTableView,
	};
}

export class settingsTableComponentCtrl {
	constructor(Cfg, Identity) {
		'ngInject';
		this.Cfg = Cfg;
		this.isUserSuperadmin = Identity.isSuperadmin();
	}

	$onInit() {
		if (this.settingsScope == 'system') {
			this.settingsModelKey = 'system_value';
		} else if (this.settingsScope == 'account') {
			this.settingsModelKey = 'account_value';
		} else if (this.settingsScope == 'hub') {
			this.settingsModelKey = 'hub_value';
		}
		this.settings.forEach(setting => {
			// cast numeric settings to Number so ngModel won't throw exception
			if (setting.input_type == 'number') {
				setting.hub_value = parseFloat(setting.hub_value);
				setting.account_value = parseFloat(setting.account_value);
				setting.system_value = parseFloat(setting.system_value);
			}
		});
	}

	save(setting) {
		setting.isSaving = true;
		this.Cfg.write(setting.code, String(setting[this.settingsModelKey]), setting.scope).then(() => {
			setting.isSaving = false;
		});
	}

	satisfiesDependencies(setting) {
		if (setting.depends_on.length === 0) {
			return true;
		}
		return setting.depends_on.every(this.testCondition.bind(this));
	}

	testCondition(condition) {
		let { code, operator, operands } = condition;
		let value = this.Cfg.read(code);
		switch (operator) {
			case '==':
			default:
				return value == operands[0];
			case '===':
				return value === operands[0];
			case '!=':
				return value != operands[0];
			case '>':
				return value > operands[0];
			case '>=':
				return value >= operands[0];
			case '<':
				return value < operands[0];
			case '<=':
				return value <= operands[0];
			case 'contains':
				return value.toLocaleLowerCase().indexOf(String(operands[0]).toLocaleLowerCase()) > -1;
			case 'not contains':
				return value.toLocaleLowerCase().indexOf(String(operands[0]).toLocaleLowerCase()) == -1;
			case 'matches':
				return new RegExp(operands[0]).test(value);
			case 'not matches':
				return new RegExp(operands[0]).test(value) == false;
			case 'in':
				return operands.indexOf(value) > -1;
			case 'not in':
				return operands.indexOf(value) == -1;
			case 'deep equals':
				return _.isEqual(value, operands[0]);
			case 'not deep equals':
				return !_.isEqual(value, operands[0]);
		}
	}
}
